import { all, fork, put, takeEvery, select } from "redux-saga/effects";
import { message } from "antd";
import { getToken } from "./../selectors/Auth";
import {
  REQUEST_USER_DETAILS,
  REQUEST_USER_REMOVE,
} from "constants/ActionTypes";
import {
  requestUserDetails,
  successUserDetails,
  successUserRemove,
  successUserDetailById,
  successUserAdd,
  successUserEdit,
  successAllUserDetails,
  successAttendanceGet,
  successAttendanceAdd,
} from "../actions/User";
import UsersApi from "../../services/user.service";
import { REQUEST_ALL_USER_DETAILS, REQUEST_ATTENDANCE_ADD, REQUEST_ATTENDANCE_GET, REQUEST_USER_ADD, REQUEST_USER_BYID, REQUEST_USER_EDIT } from "../../constants/ActionTypes";
import { push } from "react-router-redux";

function* getUsersHandler({ payload }) {
  try {
    const token = yield select(getToken);
    const usersApi = new UsersApi(token);
    const response = yield usersApi.getUsers(payload);
    if (response && response.code === 200) {
      yield put(successUserDetails(response.data));
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Internal Server Error: get getUsers");
  }
}

function* getAllUsersHandler({ payload }) {
  try {
    const token = yield select(getToken);
    const usersApi = new UsersApi(token);
    const response = yield usersApi.getAllUsers(payload);
    if (response && response.code === 200) {
      yield put(successAllUserDetails(response.data));
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Internal Server Error: get getUsers");
  }
}

function* removeUserHandler({ payload }) {
  try {
    const token = yield select(getToken);
    const userApi = new UsersApi(token);
    const response = yield userApi.removeUser(payload);
    if (response && response.code === 200) {
      yield put(successUserRemove());
      yield put(
        requestUserDetails({ page: 1, limit: 10, q: "" })
      );
      message.success(response.message);
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Internal Server Error: Delete User");
  }
}

function* getUserDetailHandler({ payload }) {
  try {
    const token = yield select(getToken);
    const userbyidApi = new UsersApi(token);
    const response = yield userbyidApi.getUserById(payload);
    if (response && response.code === 200) {
      yield put(successUserDetailById(response.data));
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Internal Server Error");
  }
}

function* addUserHandler({ payload }) {
  try {
    const token = yield select(getToken);
    const userApi = new UsersApi(token);
    const response = yield userApi.addUser(payload);
    if (response && response.code === 200) {
      yield put(successUserAdd());
      yield put(push("/database/view"));
      message.success("Success");
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Internal Server Error: Add User");
  }
}

function* editUserHandler({ payload: { id, data } }) {
  try {
    const token = yield select(getToken);
    const userApi = new UsersApi(token);
    const response = yield userApi.updateUser(id, data);
    if (response && response.code === 200) {
      yield put(successUserEdit());
      yield put(push("/database/view"));
      message.success(response.message);
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Internal Server Error");
  }
}

// Attendance Sagas

function* getAttendanceDataHandler({ payload }) {
  try {
    const token = yield select(getToken);
    const usersApi = new UsersApi(token);
    const response = yield usersApi.getAttendance(payload);
    if (response && response.code === 200) {
      yield put(successAttendanceGet(response.data));
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Internal Server Error: get getUsers");
  }
}

function* addAttendanceHandler({ payload }) {
  try {
    const token = yield select(getToken);
    const userApi = new UsersApi(token);
    const response = yield userApi.postAttendance(payload);
    if (response && response.code === 200) {
      yield put(successAttendanceAdd());
      yield put(push("/attendance/view"));
      message.success("Success");
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Internal Server Error: Add User");
  }
}


export function* getUsers() {
  yield takeEvery(REQUEST_USER_DETAILS, getUsersHandler);
}

export function* getAllUsers() {
  yield takeEvery(REQUEST_ALL_USER_DETAILS, getAllUsersHandler);
}

export function* removeUser() {
  yield takeEvery(REQUEST_USER_REMOVE, removeUserHandler);
}

export function* requestUserDetail() {
  yield takeEvery(REQUEST_USER_BYID, getUserDetailHandler);
}

export function* requestUsersAdd() {
  yield takeEvery(REQUEST_USER_ADD, addUserHandler);
}

export function* requestUserEdit() {
  yield takeEvery(REQUEST_USER_EDIT, editUserHandler);
}

// Attendance
export function* getAttendanceData() {
  yield takeEvery(REQUEST_ATTENDANCE_GET, getAttendanceDataHandler);
}

export function* postAttendance() {
  yield takeEvery(REQUEST_ATTENDANCE_ADD, addAttendanceHandler);
}

export default function* rootSaga() {
  yield all([
    fork(getUsers),
    fork(getAllUsers),
    fork(removeUser),
    fork(requestUserDetail),
    fork(requestUsersAdd),
    fork(requestUserEdit),
    fork(getAttendanceData),
    fork(postAttendance),
  ]);
}
